import { ReactElement } from "react";
import { useSize } from "./useSize";

export const AutoSizer = ({
  children,
}: {
  children: (size: { width: number; height: number }) => ReactElement;
}) => {
  const { setRef, size } = useSize();
  return (
    <div ref={setRef} style={{ width: 0, height: 0, overflow: "visible" }}>
      {children(size)}
    </div>
  );
};
